import { render, staticRenderFns } from "./NearbyOffers.vue?vue&type=template&id=7dacd932"
import script from "./NearbyOffers.vue?vue&type=script&lang=js"
export * from "./NearbyOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports